<div
  class="badge {{ color() }} size-{{ size() }} {{
    size() === 16 ? 'f-body-xs f-medium' : 'f-body-s f-medium'
  }}"
  [class.circle]="circle()"
>
  <div class="content">
    @if (leftIcon(); as leftIcon) {
      <onyx-icon [name]="leftIcon" [size]="size() === 24 ? 12 : 10"></onyx-icon>
    }

    <ng-content></ng-content>
  </div>
</div>
